module.exports = __webpack_public_path__ + "static/media/CA-Icon.ac674fcd.svg";